import React from "react"
import Navbar from "./components/Navbar"
import Problems from "./components/Problems";

function App() {

  return (
    <>
      <Navbar />
      <Problems />
    </>
  );
}

export default App;
